/**
 */

"use strict";


export class Leadership {
  /**
   * Constructor 
   */
  constructor() {
    this.init();
  }

  /**
   * Init
   *  - Finds leadership partials
   */
  init() {
    const leadership_partials = document.querySelectorAll('section.leadership');

    leadership_partials.forEach( partial => {
      const items = partial.querySelectorAll('div.item');

      this.init_items(items);
    })
  }

  /**
   * init_items
   *
   * @param {Array} items
   */
  init_items(items) {
    items.forEach( item => {
      this._add_item_click_listener(items, item);
    })
  }

  /**
   * _add_item_click_listener
   *  - Adds click listener to each item
   *    • Adds/removes active class on click
   *    • Runs through items and removes active class if they're not the current click event
   *
   * @param {Array} items
   * @param {HTMLElement} item
   */
  _add_item_click_listener(items, item) {
    item.addEventListener('click', ( () => {
      if (item.classList.contains('active')) {
        item.classList.remove('active');
      }
      else {
        item.classList.add('active');

        // Remove active class on any items that are not current click
        items.forEach( item_remove_class => {
          if ( item_remove_class != item ) {
            item_remove_class.classList.remove('active');
          }
        })

      }
    }));
  }
}
